<div class="accordion-header  {{className}}">
		<div (click)="onClick($event, index)">
			<h2 class="accordion-head">{{ title }}</h2>
			<span>{{index}}</span>
		</div>
</div>
<div class="accordion-body" [class.active]="active">
    <ng-content></ng-content>
</div>
